<template>
  <div class="deployToken" :class="{lan_En : lan != 'zh'}">
    <div class="pagecont1">
      <div class="title"><p>{{ $t('deployToken.title') }}</p></div>
      <div class="bg1"><img src="../../assets/aipro/aibg2.png" alt=""></div>
      <div class="pagecont">
        <div class="cont_left">
          <div class="list">
            <div class="listInfo delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">
              <div class=" cont_desc mb20">{{ $t('deployToken.text1') }}</div>
              <div class=" cont_desc mb20">{{ $t('deployToken.text2_1') }} <a class="nav1" href="https://dbcscan.io/" target="_blank">dbcscan.io</a> {{ $t('deployToken.text2_2') }}</div>
              <div class=" cont_desc">{{ $t('deployToken.text3') }}</div>
              <div class="text1 cont_desc ml20">{{ $t('deployToken.text3_1') }}</div>
              <div class="text1 cont_desc ml20">{{ $t('deployToken.text3_2') }}</div>
              <div class="text1 cont_desc ml20">{{ $t('deployToken.text3_3') }}</div>
              <div class="text1 cont_desc ml20">{{ $t('deployToken.text3_4') }}</div>
              <div class="text1 cont_desc ml20">{{ $t('deployToken.text3_5') }}</div>
              <div class="text1 cont_desc ml20 mb20">{{ $t('deployToken.text3_6') }}</div>
              <div class="text1 cont_desc ml20 mb20">{{ $t('deployToken.text3_7') }}</div>
              <div class="text1 cont_desc ml20 ">{{ $t('deployToken.text3_8') }}</div>
              <div class="text1 cont_desc ml20 "><a class="nav1" href="https://wizard.openzeppelin.com" target="_blank">https://wizard.openzeppelin.com</a></div>
              <div class="text1 cont_desc ml20 mb20"><a class="nav1" href="https://docs.openzeppelin.com/contracts/2.x/erc20" target="_blank">https://docs.openzeppelin.com/contracts/2.x/erc20</a></div>
              <div class=" cont_desc">{{ $t('deployToken.text4') }} <a class="nav1" href="https://github.com/DeepBrainChain/AISmartContractSample.git" target="_blank">https://github.com/DeepBrainChain/AISmartContractSample.git</a></div>
            </div>
          </div>
        </div>
        <div class="cont_right">
          <div class="bg">
            <img src="../../assets/aipro/aibg5.png" alt="">
          </div>
          <img class="delay100 animateHide" v-animate="{delay: 100, class:'amplify'}" style="filter: grayscale(100%);" src="../../assets/aipro/ai_img4.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted  } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'deployToken',
    setup() {
      const store = useStore()
      let lan = computed(() =>  store.state.lan)
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      onMounted(() => {

      });
      return {
        lan,
      };
    }
  })
</script>

<style lang="scss" scoped>
.deployToken {
  margin: auto;
  font-style: normal;
  width: 100%;
  overflow: hidden;
  position: relative;
  .cont_title {
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 20px;
    letter-spacing: 1.6px;
  }
  .cont_desc {
    font-size: 16px;
    line-height: 24px; 
    letter-spacing: 1px;
    color: rgba(255, 255, 255, .6);
  }
  .pagecont1 {
    position: relative;
    width: 100%;
    margin: auto;
    max-width: 1200px;
    padding: 80px 0 100px;
    box-sizing: border-box;    
    .bg1 {
      position: absolute;
      top: -200px;
      left: -100px;
      margin: auto;
      width: 700px;
      height: 700px;
      img {
        width: 700px;
        height: 700px;
      }
    }
    .title {
      position: relative;
      z-index: 2;
      font-size: 48px;
      font-weight: 600;
      p {
        display: inline-block;
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(90deg, #03FFF0 30%, #6409F7 70%);
      }
    }
    .pagecont {
      position: relative;
      z-index: 1;
      display: flex;
      text-align: left;
      justify-content: space-between;
      .cont_left {
        width: 560px;
        display: flex;
        margin-top: 60px;
        flex-direction: column;
        .list {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .listInfo {
            width: 100%;
            margin-bottom: 40px;
            box-sizing: border-box;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .mb20 {
            margin-bottom: 20px;
          }
          .ml20 {
            margin-left: 20px;
          }
          a {
            color: rgba(255, 255, 255, .6);
          }
          .text1 {
            color: #9DFFD4;
            .nav1 {
              color: #9DFFD4;
            }
          }
        }
      }
      .cont_right {
        position: relative;
        width: 560px;
        display: flex;
        flex-direction: column;
        .bg {
          position: absolute;
          right: -220px;
          top: -180px;
          width: 1000px;
          z-index: 1;
          img {
            width: 1000px;
          }
        }
      }
    }
    
  }
}
</style>
